module.exports = __webpack_public_path__ + "img/item-3.60dd57a.svg";